import { useEffect, useRef, useState } from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
import { useAppearance } from './AppearanceProvider';

// Stable bounds and motion values keep pointer movement out of React rendering.
export default function KineticSurface({ children, className = '', depth = 5 }) {
  const root = useRef(null), reduced = useReducedMotion(), {preferences} = useAppearance();
  const [visible, setVisible] = useState(true);
  const x = useMotionValue(0), y = useMotionValue(0);
  const rotateX = useSpring(x, {stiffness: 110, damping: 24, mass: .6});
  const rotateY = useSpring(y, {stiffness: 110, damping: 24, mass: .6});
  const settle = () => { x.set(0); y.set(0); };
  useEffect(() => {
    if (!root.current || typeof IntersectionObserver !== 'function') return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
    observer.observe(root.current); return () => observer.disconnect();
  }, []);
  useEffect(() => { if (reduced || preferences.quiet || !visible) { x.set(0); y.set(0); } }, [reduced, preferences.quiet, visible, x, y]);
  return <div ref={root} className={`tl-kinetic-stage ${className}`} data-kinetic-active={visible && !reduced && !preferences.quiet} onPointerMove={event => {
    if (event.pointerType !== 'mouse' || event.buttons || reduced || preferences.quiet || !visible || document.hidden) return;
    const bounds = root.current.getBoundingClientRect();
    x.set(-Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1)) * depth);
    y.set(Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1)) * depth);
  }} onPointerLeave={settle} onPointerDown={settle} onBlur={settle}>
    <motion.div className="tl-kinetic-surface" style={{rotateX, rotateY}}>{children}</motion.div>
  </div>;
}
